import { Link } from 'react-router-dom';
import './ActivationCodesPage.css';

const MOCK_CODES = [
  {
    id: 'aurora',
    name: '極光主題 AURORA',
    machine: 'DARTSLIVE 3 · 主題卡',
    theme: 'aurora',
    code: 'AUR3 · K27P · QF8M',
    status: 'bound',
    statusLabel: '已綁定',
    boundInfo: '已綁定至 Player ID · TORU_5183 · 2025/11/08 19:42',
    order: 'MD-251108-0428',
    expiry: '永久使用',
  },
  {
    id: 'neon',
    name: '霓虹東京 NEON TOKYO',
    machine: 'DARTSLIVE 3 · 動畫主題',
    theme: 'neon',
    code: 'NEON · TOK3 · X9R7',
    status: 'unbound',
    statusLabel: '待綁定',
    boundInfo: '尚未綁定 Player ID · 啟用碼 90 天內有效',
    order: 'MD-251108-0428',
    expiry: '剩 88 天',
  },
  {
    id: 'sakura',
    name: '櫻花季限定 SAKURA',
    machine: 'DARTSLIVE 2 · 季節主題',
    theme: 'sakura',
    code: 'SAK2 · 25SP · BL44',
    status: 'bound',
    statusLabel: '已綁定',
    boundInfo: '已綁定至 Player ID · TORU_5183 · 2025/04/01 14:08',
    order: 'MD-250401-0019',
    expiry: '2025/06/30 到期 · 季節限定',
  },
  {
    id: 'cyber',
    name: '網絡駭客 CYBER',
    machine: '隨 PHOENICA CARD · PRO 附贈',
    theme: 'cyber',
    code: 'CY3R · BUND · LE92',
    status: 'bound',
    statusLabel: '已綁定',
    boundInfo: '已綁定至 Phoenix ID · CHIA_WEI · 隨卡到貨自動掛載',
    order: 'MD-251023-0317',
    expiry: '永久使用',
  },
];

function FakeQR() {
  const cells = [];
  for (let y = 0; y < 21; y++) {
    for (let x = 0; x < 21; x++) {
      const inCorner = (cx, cy) => x >= cx && x < cx + 7 && y >= cy && y < cy + 7;
      const inInnerCorner = (cx, cy) => x >= cx && x < cx + 3 && y >= cy && y < cy + 3;
      let fill = false;
      if (inCorner(0, 0) || inCorner(14, 0) || inCorner(0, 14)) {
        const onEdge = (
          (inCorner(0, 0) && (x === 0 || x === 6 || y === 0 || y === 6)) ||
          (inCorner(14, 0) && (x === 14 || x === 20 || y === 0 || y === 6)) ||
          (inCorner(0, 14) && (x === 0 || x === 6 || y === 14 || y === 20))
        );
        if (onEdge) fill = true;
        if (inInnerCorner(2, 2) || inInnerCorner(16, 2) || inInnerCorner(2, 16)) fill = true;
      } else {
        fill = (x * 7 + y * 13 + x * y) % 3 === 0;
      }
      if (fill) cells.push(<rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="#14276A" />);
    }
  }
  return <svg viewBox="0 0 21 21" shapeRendering="crispEdges">{cells}</svg>;
}

function ActivationCodesPage() {
  return (
    <main className="act">
      <header className="act-head">
        <nav className="act-crumbs">
          <Link to="/account">會員中心</Link> / <b>虛擬商品 / 啟用碼</b>
        </nav>
        <h1>我的虛擬商品 · 啟用碼</h1>
        <p>每筆購買都會收到一組 12 碼啟用碼 + QR Code。複製貼上機台、或用 DARTSLIVE / PHOENIXdarts APP 掃描 QR 即可綁定到你的 Player ID。已綁定的主題會立刻出現在機台選單。</p>
      </header>

      <div className="act-grid">
        {MOCK_CODES.map(item => (
          <article key={item.id} className="act-card">
            <div className="act-card-head">
              <div className={`act-thumb ${item.theme}`} />
              <div className="act-info">
                <h3>{item.name}</h3>
                <span className="act-machine">{item.machine}</span>
              </div>
              <span className={`act-status ${item.status}`}>{item.statusLabel}</span>
            </div>

            <div className="act-code-block">
              <p className="act-lbl">ACTIVATION CODE</p>
              <div className="act-code-row">
                <span className="act-code">{item.code}</span>
                <button className="act-copy-btn">複製</button>
              </div>
            </div>

            {item.status === 'unbound' && (
              <div className="act-qr-area">
                <div className="act-qr"><FakeQR /></div>
                <div className="act-qr-info">
                  <b>用 DARTSLIVE APP 掃描</b>
                  登入 APP → 「我的物品」→ 右上 + → 掃描 QR
                </div>
              </div>
            )}

            <div className={`act-bound-info${item.status === 'unbound' ? ' warn' : ''}`}>
              <span>{item.boundInfo}</span>
            </div>

            <div className="act-foot">
              <div className="act-meta">
                <span>訂單 #{item.order}</span>
                <span>{item.expiry}</span>
              </div>
              <div className="act-actions">
                {item.status === 'bound' ? (
                  <>
                    <button>下載 QR</button>
                    <button>查看機台教學</button>
                  </>
                ) : (
                  <>
                    <button>重寄到 Email</button>
                    <button className="primary">前往 APP →</button>
                  </>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}

export default ActivationCodesPage;
